(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/hooks/use-account-balance.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/hooks/use-account-balance.js');

'use strict';

const {
  useState,
  useEffect
} = React;
const svsUtilsformatCurrency = svs.utils.format.Currency;
const {
  accountSelector
} = svs.numbergames;
const showTeamErrorDialog = text => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.ERROR,
    title: 'Hoppsan!',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text
    }],
    actions: [{
      title: 'Okej'
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showTeamNotActiveMemberProlongErrorDialog = () => showTeamErrorDialog('Du vill förlänga ett lagspel där du inte längre är medlem. Vi ändrar så du betalar från ditt eget spelkonto.');
const useAccountBalance = (syndicateId, isSyndicate) => {
  const [accountBalance, setAccountBalance] = useState();
  const [isInitialised, setIsInitialised] = useState(false);
  const [accountIsSyndicate, setAccountIsSyndicate] = useState(false);
  useEffect(() => {
    const getAccountBalance = async () => {
      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        var _response, _response2;
        let response;
        if (syndicateId && isSyndicate) {
          try {
            response = await accountSelector.setActiveAccount(syndicateId);
          } catch (e) {
            showTeamNotActiveMemberProlongErrorDialog();
            response = await accountSelector.usePlayerAccount();
          }
        } else {
          response = await accountSelector.usePlayerAccount();
        }
        setAccountIsSyndicate((_response = response) === null || _response === void 0 ? void 0 : _response.isSyndicate);
        setAccountBalance(svsUtilsformatCurrency((_response2 = response) === null || _response2 === void 0 ? void 0 : _response2.balance));
      } else {
        setAccountIsSyndicate(syndicateId && isSyndicate);
      }
      setIsInitialised(true);
    };
    getAccountBalance();
    return () => {
      accountSelector.usePlayerAccount();
    };
  }, [isSyndicate, syndicateId]);
  return {
    accountBalance,
    isInitialised,
    accountIsSyndicate
  };
};
setGlobal('svs.numbergames.prolong_game.hooks.useAccountBalance', useAccountBalance);

 })(window);